import { useRouter } from 'next/router'
import { ArrowBackIcon } from '../Icons'
import { Button } from '../Button'
import { UrlObject } from 'url'

export interface BackButtonProps {
  className?: string
  text?: string
  url?: string | UrlObject
  onClick?: () => void
  width?: number
}

export const BackButton = ({ url, text, className, onClick, width }: BackButtonProps) => {
  const router = useRouter()
  const goBack = () => router.back()
  const goToUrl = () => url && router.push(url)

  return (
    <Button
      width={width}
      onClick={onClick ?? (url ? goToUrl : goBack)}
      view="secondary"
      size={text ? 'medium' : 'small'}
      className={className}
      narrow={!text}
      icon={<ArrowBackIcon size={text ? 16 : 24} />}
      iconPosition="left"
    >
      {text && <span>{text}</span>}
    </Button>
  )
}
